// --- START OF FILE public/landingpage/js/index-landing.js ---

/**
 * index-landing.js v1.1 - Parcel Entry Point
 * Punto di ingresso principale per gli script della landing page,
 * gestito da Parcel. Assicura il corretto ordine di caricamento dei moduli.
 */

console.log("[Index Landing] Inizio caricamento moduli per la landing page (v1.1)...");

// 1. Configurazione Firebase (essenziale, deve essere il primo dei tuoi moduli custom)
//    Definisce window.firebaseServices e la persistenceSetupPromise.
//    Il percorso è relativo dalla posizione di questo file (landingpage/js/)
//    a js/firebase/config.js
import '../../js/firebase/config.js';

// 2. Definizioni delle Classi Manager e Dati Globali
//    Questi script definiscono le classi (es. class AuthManager {}) e
//    dati globali (es. window.ACHIEVEMENT_DEFINITIONS).
//    Le ISTANZE dei manager (es. new AuthManager()) verranno create
//    in landingpage/js/main.js, che viene importato più avanti.
//    L'ordine qui è importante se ci sono dipendenze tra le definizioni stesse
//    (improbabile per le sole definizioni di classe).

// Dati Achievement (usato da AchievementManager)
import '../../js/utils/achievementsData.js';

// Definizioni Classi Manager Firebase
import '../../js/firebase/auth.js';       // Definisce la classe AuthManager
import '../../js/firebase/profile.js';    // Definisce la classe ProfileManager
import '../../js/firebase/leaderboard.js';// Definisce la classe LeaderboardManager

// Definizioni Classi Manager Generali
import '../../js/managers/AudioManager.js'; // Definisce la classe AudioManager
import '../../js/managers/AchievementManager.js'; // Definisce la classe AchievementManager

// 3. Moduli UI specifici della Landing Page
//    Questi definiscono le IIFE che si attaccano a window.LandingPageAuthUI, ecc.
//    e vengono inizializzate da landingpage/js/main.js.
import './auth-ui.js';
import './leaderboard-ui.js';
import './profile-ui.js';

// 4. Dati Video
//    Definisce window.latestVideoData, usato da landingpage/js/main.js.
import './video.js';

// 5. Script principale della Landing Page
//    Questo file (landingpage/js/main.js) contiene la logica per
//    inizializzare i manager (new AuthManager(), ecc.) e legare gli eventi UI.
//    Deve venire DOPO che tutte le classi e i dati globali sono stati definiti/importati.
import './main.js';

console.log("[Index Landing] Tutti i moduli per la landing page importati e pronti (v1.1).");

// --- END OF FILE public/landingpage/js/index-landing.js ---